import * as React from "react";
import { IdStyles } from "../../../../less/IdStyles";
import { IdLoca } from "../../../../utils/i18n/IdLoca";
import { ButtonPrimary } from "../../../generic/common/ButtonPrimary";
import { TextLoca } from "../../../generic/text/TextLoca";
import { IdTutorialFocusElement } from "../../../tutorial/IdTutorialFocusElement";
export var QuestItemButton = function (_a) {
    var quest = _a.quest, isCollectBtnDisabled = _a.isCollectBtnDisabled, onClick = _a.onClick;
    return (React.createElement("div", { id: IdTutorialFocusElement.quest_collect },
        React.createElement(ButtonPrimary, { onClick: function () { return onClick(quest.id); }, disabled: isCollectBtnDisabled },
            React.createElement("div", { className: IdStyles.TextBoldAccent },
                React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.collect })))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/QuestItemButton.tsx
// module id = 2660
// module chunks = 3